import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Config } from "../_store";
import * as pako from "pako";

@Injectable({
    providedIn: "root",
})
export class InvoiceService {
    invoice: any;
    invoiceFile: any;
    fileElement: any;
    documents: any;
    invoiceType: any;
    invType: any;
    fileUrl: any;
    nonPOFields: any;
    digitalInvoiceData: any;
    username: any;
    userId: any;
    logisticsPoNumber: any;

    constructor(private http: HttpClient) {}

    fecthInvoices(data: any) {
        return this.http.post(Config.urls.INVOICES, data);
    }

    extractInvoice(data: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                "Accept-Encoding": "gzip, deflate, br",
                "Content-Transfer-Encoding": "application/gzip",
                "Transfer-Encoding": "application/gzip",
            }),
        };

        //const compressedFormData = pako.gzip(JSON.stringify(data));

        return this.http.post(Config.urls.EXTRACTINVOICE, data, httpOptions);
    }

    reExtractInvoice(data: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                "Accept-Encoding": "gzip, deflate, br",
                "Content-Transfer-Encoding": "application/gzip",
                "Transfer-Encoding": "application/gzip",
            }),
        };

        //const compressedFormData = pako.gzip(JSON.stringify(data));
        return this.http.post(Config.urls.REXTRACTINVOICE, data, httpOptions);
    }

    uploadInvoice(data: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                "Accept-Encoding": "gzip, deflate, br",
                "Content-Transfer-Encoding": "application/gzip",
                "Transfer-Encoding": "application/gzip",
            }),
        };
        return this.http.post(Config.urls.SUBMITINVOICE, data, httpOptions);
    }

    uploadInvoiceWithoutExtration(data: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                "Accept-Encoding": "gzip, deflate, br",
                "Content-Transfer-Encoding": "application/gzip",
                "Transfer-Encoding": "application/gzip",
            }),
        };
        return this.http.post(
            Config.urls.SUBMITINVOICEWITHOUTEXTRACT,
            data,
            httpOptions
        );
    }

    saveInvoice(data: any) {
        return this.http.post(Config.urls.SAVEINVOICE, data);
    }

    verifyDigitalSignature(data: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                "Accept-Encoding": "gzip, deflate, br",
                "Content-Transfer-Encoding": "application/gzip",
                "Transfer-Encoding": "application/gzip",
            }),
        };

        //const compressedFormData = pako.gzip(JSON.stringify(data));
        return this.http.post(Config.urls.VERIFYSIGNATURE, data, httpOptions);
    }

    sendInvoiceToJSW(data: any) {
        return this.http.post(Config.urls.SUBMITINVOICETOJSW, data);
    }

    fetchConfig(data: any) {
        return this.http.post(Config.urls.FETCHCONFIG, data);
    }

    setProcessedInvoice(data: any) {
        this.invoice = data;
    }

    getProcessedInvoice() {
        return this.invoice;
    }

    setUsername(data: any) {
        this.username = data;
    }
    getUsername() {
        return this.username;
    }

    setPo(data: any) {
        this.logisticsPoNumber = data;
    }
    getPo() {
        return this.logisticsPoNumber;
    }

    setUserId(data: any) {
        this.userId = data;
    }

    getUserId() {
        return this.userId;
    }

    setInvoiceFile(file: any) {
        this.invoiceFile = file;
    }

    getInvoiceFile() {
        return this.invoiceFile;
    }

    setNonPOFields(fields: any) {
        this.nonPOFields = fields;
    }

    getNonPOFields() {
        return this.nonPOFields;
    }

    setFileElement(element: any) {
        this.fileElement = element;
    }

    getFileElement() {
        return this.fileElement;
    }

    setDocuments(element: any) {
        this.documents = element;
    }

    getDocuments() {
        return this.documents;
    }

    setInvType(type: any) {
        this.invType = type;
    }

    getInvType() {
        return this.invType;
    }

    setInvoiceType(type: any) {
        this.invoiceType = type;
    }

    getInvoiceType() {
        return this.invoiceType;
    }

    setFileUrl(type: any) {
        this.fileUrl = type;
    }

    getFileUrl() {
        return this.fileUrl;
    }

    setDataDigitalInvoice(data: any) {
        this.digitalInvoiceData = data;
    }

    getDataDigitalInvoice() {
        return this.digitalInvoiceData;
    }
}
